import { useAppSelector } from '@customer/store/hooks';
import { useEffect, useRef } from 'react';
import { To, useNavigate } from 'react-router-dom';

export const useSiteSwitchWatcher = (redirectTo: To): void => {
  const navigate = useNavigate();

  const siteId = useAppSelector(state => state.auth.siteId);

  const siteRef = useRef<string | undefined>(siteId);

  useEffect(() => {
    const previousSiteId = siteRef.current;

    if (siteId !== previousSiteId) {
      // Update an internal record of the siteId if it has changed.
      siteRef.current = siteId;

      // Only redirect if the siteId has changed after being valid (not undefined).
      if (typeof previousSiteId !== 'undefined') {
        navigate(redirectTo);
      }
    }
  }, [siteId, navigate, redirectTo]);
};
